import { render, staticRenderFns } from "./SupportTicketDetails.vue?vue&type=template&id=7a0522ca&scoped=true"
import script from "./SupportTicketDetails.vue?vue&type=script&lang=js"
export * from "./SupportTicketDetails.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketDetails.vue?vue&type=style&index=0&id=7a0522ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0522ca",
  null
  
)

export default component.exports